<template>
  <v-overlay
    absolute
    z-index=0
    class="fullcontent">
    <v-img
      :src="backGroundImg"
      height="100vh"
      position="center center"
      gradient="to top right, rgba(0, 9, 58, 0.33), rgba(18, 24, 62, 0.7)"
    ></v-img>
  </v-overlay>
</template>

<script>
import { createNamespacedHelpers, mapState, mapActions } from 'vuex'
const { mapState:authState } = createNamespacedHelpers('auth')
export default {
  computed:{
    ...authState(['user']),
    backGroundImg() {
      const imgs = {
        '/samtronic': 'https://storage.googleapis.com/uf-manage.appspot.com/customers/samtronic/samtronic.png',
        '/portao_cambui': 'https://storage.googleapis.com/download/storage/v1/b/botuf-userfunction.appspot.com/o/banner-portao-1732565511775.jpg-1732565511780?generation=1732565513137311&alt=media'
      }
      return imgs[this.$router.history.current.path] || require('@/assets/bg.jpg')
    }
  },
  created(){

  }

}
</script>

<style>

</style>